import React from "react";


import node from "../assets/node.png"
import github from "../assets/github.png";
import agil from "../assets/agil.png";
import wordpress from "../assets/wordpress.png"
import figma from "../assets/figma.png"
import php from "../assets/php.png";
import express from  "../assets/exp.png"
import symfoni from "../assets/symfoni.png"
import mysql from "../assets/mysql.png"
import mongoDb from "../assets/mongoDb.png"


const Backend = () => {


  var techsBack =[
    {
      id: 4,
      src: symfoni,
      title: "Symfoni",
      style: "shadow-gray-600",
    },
    {
      id: 4,
      src: mysql,
      title: "MySQL",
      style: "shadow-blue-400",
    },
    {
      id: 6,
      src: node,
      title: "Node JS",
      style: "shadow-green-400",
    },

    {
      id: 8,
      src: express,
      title: "Express",
      style: "shadow-gray-400",
    },
    {
      id: 8,
      src: php,
      title: "PHP",
      style: "shadow-blue-300",
    },
    {
      id: 8,
      src: mongoDb,
      title: "mongoDb",
      style: "shadow-amber-900",
    },
    
    
  ]

    
  var otherSkills =[
    {
        id: 1,
        src: github,
        title: "GitHub",
        style: "shadow-gray-400",
      },
      {
        id: 2,
        src: agil,
        title: "Methode agil",
        style: "shadow-sky-400",
      },
      {
        id: 3,
        src: wordpress,
        title: "wordpress",
        style: "shadow-blue-400",
      },
      {
        id: 3,
        src: figma,
        title: "Figma",
        style: "shadow-amber-900",
      },
    
    
  ]

  return (
    <div
      name="backend"
      className="bg-gradient-to-b from-black to-gray-800 w-full w-full h-screen"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        
        <div className="mt-80">
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
          Competences Back-End : 
          </p>
          
        </div>
        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techsBack.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg m-5 ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
          
        </div>
        <br />
       

      </div>
      
    </div>
  );
};

export default Backend;